"use strict";
exports.__esModule = true;
exports.chart_errorbar_data_stroke_Width = {
  "name": "--pf-chart-errorbar--data-stroke--Width",
  "value": 2,
  "var": "var(--pf-chart-errorbar--data-stroke--Width, 2)"
};
exports["default"] = exports.chart_errorbar_data_stroke_Width;